import { serverUrl } from "../config";
const sessionApi = async (amount, mines, clientId) => {
  try {
    let req = {
      data: {
        numberOfCells: 25,
        bombCounter: mines,
        clientBet: amount,
        clientId: clientId,
      },
    };

    const res = await fetch(`${serverUrl}/session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req),
    });

    if (res.ok) {
      const jsonData = await res.json();
      return {
        clientId: jsonData["clientId"],
        currentBalance: jsonData["data"]["currentBalance"],
        currentMultiplier: jsonData["data"]["currentMultiplier"],
        nextMultiplier: jsonData["data"]["nextMultiplier"],
        numOfCells: jsonData["data"]["numOfCells"],
      };
    }
  } catch (e) {
    console.error(e);
  }
};
export default sessionApi;
